import request from '@/utils/request'

const baseUrl = '/erp/price-system'

export const listPriceSystem = params => request({ url: baseUrl + '/list', method: 'get', params })
export const getPriceSystem = id => request({ url: baseUrl + '/detail', method: 'get', params: { id } })
export const savePriceSystem = data => request({ url: baseUrl + '/save', method: 'post', data })
export const setPriceSystemEnabled = (id, enabled) => request({
  url: baseUrl + '/status', method: 'post', data: { id, enabled }
})
